import { render, staticRenderFns } from "./LiveImage.vue?vue&type=template&id=42ff97e7&scoped=true"
import script from "./LiveImage.vue?vue&type=script&lang=ts"
export * from "./LiveImage.vue?vue&type=script&lang=ts"
import style0 from "./LiveImage.vue?vue&type=style&index=0&id=42ff97e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff97e7",
  null
  
)

export default component.exports